<template>
   <div :class="addClasses" >
      <span :class="[checkNotification(status) ? 'color-success':'color-danger']">
        {{ getStatus(status) }}
    </span>
   </div>
</template>

<script>
    export default {
        name: "NotificationStatus",
        props: ['status', 'isResult','addClasses'],
        methods: {
            checkNotification( status ) {
                if ( this.isResult && status !== 'RESULT_SENT' )
                    return false;

                if ( status === 'RESULT_SENT' || status === 'SENT' || status === 'EVENT_CANCEL_SENT' )
                    return true;

                return false;
            },
            getStatus( status ) {
                if ( this.isResult ) {
                    if ( status === 'SENT' )
                        return this.getTranslation( 'NOTIFICATION_NOT_SENT' );
                    else if ( status === 'RESULT_SENT' )
                        return this.getTranslation( 'NOTIFICATION_RESULT_SENT' );
                    else
                        return this.getTranslation( 'NOTIFICATION_' + status );
                }
                else {
                    return this.getTranslation( 'NOTIFICATION_' + status );
                }
            }
        }
    }
</script>

<style scoped>

</style>
